<template>
  <div class="vacancies">
    <template
      v-for="block in blok.body"
      :key="block._uid"
    >
      <template v-if="block.component === 'vacancy-list'">
        <div class="title">
          <h1>{{ blok.title }}</h1>
          <div class="separator" />
        </div>
        <div class="content">
          <div class="sidebar">
            <VacancyFilter :blok="filterBlok" />
          </div>
          <div class="separator" />
          <StoryblokComponent :blok="block" />
        </div>
      </template>
      <StoryblokComponent
        v-else
        :blok="block"
        :department="departmentsBlok"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
  import VacancyFilter from '@/storyblok/Vacancy/VacancyFilter.vue'

  const props = defineProps<{ blok: any }>()

  const departmentsBlok = computed(() => ({ heroImage: props.blok.mobileHeroImage }))

  const filterBlok = computed(() => ({
    teamsPlaceholder: props.blok.filterTeamsPlaceholder,
    filterClearLabel: props.blok.filterClearLabel,
    filterTeamsLabel: props.blok.filterTeamsLabel,
    filterTeamsPlaceholder: props.blok.filterTeamsPlaceholder,
    filterSearchPlaceholder: props.blok.filterSearchPlaceholder
  }))
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .vacancies {
    color: $bt-blue;
    margin: auto;
    max-width: 1440px;
    width: 100%;

    .title {
      display: none;

      @include tablet-up {
        display: block;
        margin: 0 auto;
        text-align: center;
      }

      h1 {
        margin: rem(8);
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      margin: auto;
      max-width: 1120px;
      padding: rem(24) rem(20) 0;
      width: calc(100% - rem(20) * 2);

      @include tablet-up {
        flex-direction: row;
        padding: 0 rem(32);
        width: calc(100% - rem(32) * 2);
      }

      .sidebar {
        @include tablet-up {
          margin-right: rem(32);
          min-width: 256px;
        }
      }

      .separator {
        margin: rem(24) auto;

        @include tablet-up {
          display: none;
        }
      }
    }
  }
</style>
